import { z } from 'zod'

/**
 * Single error envelope for every endpoint. `message` is the German text shown to the user,
 * `code` is the stable identifier the frontend may branch on. Nothing secret ever goes in
 * here — see `redact()` in @kontor/core.
 */
export const apiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    /** Field-level validation problems, if the request failed schema validation. */
    issues: z
      .array(
        z.object({
          path: z.string(),
          message: z.string(),
        }),
      )
      .optional(),
  }),
})

export type ApiError = z.infer<typeof apiErrorSchema>
